import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Main from '../../layouts/Main';
import Container from '../../components/Container';
import {
  Hero,
  FeaturedServices,
  LatestNews,
  LatestEvents,
  Subscription,
  TrainingCourses,
} from './components';

import FollowTheMoney from './components/FollowTheMoney';
import MunicipalMap from './components/MunicipalMap';

const Home1 = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Main>
      {/*Search*/}
      <Hero />
      {/*Services*/}
      <Container>
        <FeaturedServices />
      </Container>
      {/*Data search*/}
      <Box
       sx={{
          backgroundColor: theme.palette.alternate.main,
        }}
      >
        <Container>
          <FollowTheMoney></FollowTheMoney>
        </Container>
      </Box>
      {/*News*/}
      <Box
        position={'relative'}
      > 
        <Box>
            <Box>
              <Typography
              variant="h4"
              align={'center'}
              data-aos={'fade-up'}
              gutterBottom
              fontWeight={700}
              paddingTop={4}
            >
                News & Events
              </Typography>
            </Box>
            <Container>
              <Grid container spacing={isMd ? 4 : 0}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <LatestNews />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <LatestEvents />
              </Grid>
            </Grid>
            </Container>
        </Box>
        <Box
          component={'svg'}
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 1920 100.1"
          sx={{
            width: '100%',
            marginBottom: theme.spacing(-1),
          }}
        >
          <path
            fill={theme.palette.background.paper}
            d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
          ></path>
        </Box>
      </Box>
      <Box>
        <Container>
          <MunicipalMap />
        </Container>
      </Box>
      <Box
       sx={{
        backgroundColor: theme.palette.alternate.main,
      }}  
      >
        <Container>
          <TrainingCourses />
        </Container>
      </Box>
       {/*Subscription*/}
      <Box
        sx={{
          background: 'transparent',
          backgroundImage: `linear-gradient(180deg, ${theme.palette.background.paper} 40%, ${theme.palette.primary.main} 0%)`,
        }}
      >
        <Container>
          <Subscription />
        </Container>
      </Box>
    </Main>
  );
};

export default Home1;
